module.exports = __webpack_public_path__ + "media/images/brands/brand-cv-bdd3aeca2d8c2965216128290228780b.jpg";